<div class="text">
    <div class="main">
        <ng-content select="[primary-text]"></ng-content>
    </div>
    <div class="secondary">
        <ng-content select="[secondary-text]"></ng-content>
    </div>
</div>
<div class="icon">
    <img [src]="settings.getAssetUrl() + 'images/no-results.svg'">
</div>


// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/node_modules/vebto-client/core/ui/no-results-message/no-results-message.component.html